// @flow
import { useCallback, useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import { api } from 'app/api';
import { GET_SUMMARY, convertResult, convertParams } from 'app/common/api/requests/cabinet/dnevnik/summary';
import type { Params, SummaryMarks } from 'app/dataTypes/SummaryMarks.types';
import type { Discipline } from 'app/dataTypes/Discipline.types';


export default function useSummaryMarks(
  { klassId, studentId, date }: Params,
  onUpdateDIsciplines: (Array<Discipline>) => void
): [
  SummaryMarks,
  boolean
] {
  const { t } = useTranslation('app');
  const [summaryMarks, setMarks] = useState<SummaryMarks>({});
  const [loading, setLoading] = useState(true);

  const request = useCallback(async () => {
    setLoading(true);
    const res = await api.request(GET_SUMMARY, {
      error: t('request_dnevnik_final_marks_failed'),
      params: { klassId, studentId, date },
      convertions: { convertParams, convertResult },
    });
    if (res) {
      const [ds, sm] = res;
      onUpdateDIsciplines(ds);
      setMarks(sm);
    }
    setLoading(false);
  }, [klassId, studentId, date, t, onUpdateDIsciplines]);

  useEffect(() => {
    request();
  }, [request]);

  return [summaryMarks, loading];
}
